/**
 * Shared cell editor styles. Imported by each editor component.
 * These must live in each component's styles because Angular's emulated
 * ViewEncapsulation prevents parent styles from reaching child templates.
 */
export const CELL_EDITOR_STYLES = `
  :host { display: contents; }

  .cell-input {
    width: 100%;
    max-width: 100%;
    height: 100%;
    padding: 8px 16px;
    border: none;
    border-radius: 0;
    font-size: var(--og-font-size-sm, 14px);
    font-family: inherit;
    color: var(--og-text-primary, rgba(0, 0, 0, 0.87));
    background: transparent;
    box-sizing: border-box;
  }
  .cell-input:focus {
    outline: none;
  }
  .cell-input:focus-visible {
    outline: 2px solid var(--og-primary, #4b3fff);
    outline-offset: -2px;
  }
  .cell-input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
  .cell-input[type="number"]::-webkit-outer-spin-button,
  .cell-input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  .cell-listbox-wrapper {
    position: relative;
    width: 100%;
  }
  .cell-listbox-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 8px 16px;
    border: none;
    border-radius: 0;
    background: transparent;
    color: var(--og-text-primary, rgba(0, 0, 0, 0.87));
    font-size: inherit;
    font-family: inherit;
    line-height: 1.4;
    cursor: pointer;
    text-align: left;
  }
  .cell-listbox-trigger:focus {
    outline: none;
  }
  .cell-listbox-trigger:focus-visible {
    outline: 2px solid var(--og-primary, #4b3fff);
    outline-offset: -2px;
  }
  .select-chevron {
    flex-shrink: 0;
    margin-left: 4px;
    color: var(--og-text-disabled, rgba(0, 0, 0, 0.54));
  }
  .cell-listbox {
    z-index: 9999;
    min-width: 180px;
    max-width: 300px;
    max-height: 200px;
    overflow-y: auto;
    padding: 4px 0;
    background: #ffffff;
    border: 1px solid var(--og-border-light, rgba(0, 0, 0, 0.12));
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
  .listbox-option {
    display: flex;
    align-items: center;
    min-height: 36px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 0.875rem;
    color: var(--og-text-primary, rgba(0, 0, 0, 0.87));
    transition: background 0.1s ease;
    user-select: none;
  }
  .listbox-option:hover,
  .listbox-option.highlighted {
    background: var(--og-bg-hover, rgba(0, 0, 0, 0.04));
  }
  .listbox-option.selected {
    background: rgba(75, 63, 255, 0.08);
    font-weight: 600;
    color: var(--og-primary, #4b3fff);
  }
  .listbox-option.selected.highlighted {
    background: rgba(75, 63, 255, 0.12);
  }
  .listbox-option.highlighted {
    outline: 2px solid var(--og-primary, #4b3fff);
    outline-offset: -2px;
    border-radius: 4px;
  }
`;
